import React from 'react';
import { ShieldCheck, Zap, Brain } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-slate-50 py-16 sm:py-24" data-id="element-234">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="mx-auto max-w-3xl text-center mb-12" data-id="element-236">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4 font-serif" data-id="element-237">
            Presentamos el Kit de Emergencia SOS Ansiedad
          </h2>
          <p className="text-lg text-slate-600" data-id="element-238">
            No es un libro de teoría. Es un manual táctico diseñado para hackear
            tu sistema nervioso a través del cuerpo.
          </p>
        </div>

        {/* Mockup + feature cards */}
        <div className="mx-auto max-w-5xl flex flex-col lg:flex-row items-center gap-10 mb-16" data-id="element-239">
          {/* Product mockup */}
          <div className="w-full lg:w-72 flex-shrink-0" data-id="element-240">
            <div className="relative" data-id="element-241">
              <div className="absolute inset-0 -z-10 bg-blue-100 rounded-2xl blur-2xl opacity-60 scale-95" data-id="element-242"></div>
              <img src="https://cdn.magicpatterns.com/uploads/ieofY1sYRittGmMbu51h58/heylloyd-image-1771635543413.png" alt="Vista previa del Kit SOS Ansiedad" className="w-full h-auto rounded-xl shadow-xl shadow-slate-200/80 object-cover" data-id="element-243" />
              <div className="mt-4 text-center" data-id="element-244">
                <p className="text-xs text-slate-400 font-sans italic" data-id="element-245">
                  Acceso inmediato al PDF desde tu celular
                </p>
              </div>
            </div>
          </div>

          {/* Feature cards */}
          <div className="flex-1 grid grid-cols-1 gap-4 w-full" data-id="element-246">
            <div className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex items-start gap-4" data-id="element-247">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 text-blue-600" data-id="element-248">
                <Zap className="w-5 h-5" data-id="element-249" />
              </div>
              <div data-id="element-250">
                <h3 className="text-lg font-bold text-slate-900 mb-1 font-serif" data-id="element-251">
                  Acción Rápida
                </h3>
                <p className="text-slate-600 text-sm" data-id="element-252">
                  Técnicas de <i data-id="element-253">grounding</i> para salir del modo pánico en
                  menos de 5 minutos.
                </p>
              </div>
            </div>

            <div className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex items-start gap-4" data-id="element-254">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 text-purple-600" data-id="element-255">
                <Brain className="w-5 h-5" data-id="element-256" />
              </div>
              <div data-id="element-257">
                <h3 className="text-lg font-bold text-slate-900 mb-1 font-serif" data-id="element-258">
                  Neurociencia Aplicada
                </h3>
                <p className="text-slate-600 text-sm" data-id="element-259">
                  Forzamos a tu cerebro a volver a la calma funcional usando
                  mecanismos biológicos.
                </p>
              </div>
            </div>

            <div className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex items-start gap-4" data-id="element-260">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 text-green-600" data-id="element-261">
                <ShieldCheck className="w-5 h-5" data-id="element-262" />
              </div>
              <div data-id="element-263">
                <h3 className="text-lg font-bold text-slate-900 mb-1 font-serif" data-id="element-264">
                  100% Práctico
                </h3>
                <p className="text-slate-600 text-sm" data-id="element-265">
                  Sin relleno teórico. Solo herramientas que podés usar en el
                  colectivo, la oficina o tu casa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}